import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcEssentialStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 11,
	viewBox: "0 0 12 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.39062 10.957L3.70312 6.96094L0.304688 4.51172H4.48828L5.77734 0.539062L7.07812 4.51172H11.2617L7.875 6.96094L9.17578 10.957L5.77734 8.49609L2.39062 10.957Z",
		fill: "white"
	})
});
export default SvgIcEssentialStar;
